import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {Store} from "../../models/store";
import {UiSelectComponent, UiSelectOption} from "../../shared/ui";

@Component({
  selector: 'app-store-selector',
  imports: [
    UiSelectComponent
  ],
  templateUrl: './store-selector.component.html',
  styleUrl: './store-selector.component.scss'
})
export class StoreSelectorComponent implements OnChanges {

  @Input() stores: Store[] = [];
  @Input() preSelect: number | 'auto' | undefined;
  @Output() storeSelected = new EventEmitter<Store>();
  @Input() direction: 'vertical' | 'horizontal' = 'vertical';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  selectedStoreId: string = '';
  options: UiSelectOption[] = [];

  ngOnChanges(): void {
    this.updateOptions();
    this.preSelectStore();
  }

  updateOptions(): void {
    this.options = this.stores.map(store => ({
      value: store.id?.toString() || '',
      label: store.name || '',
      disabled: false
    }));
  }

  preSelectStore() {
    if (this.preSelect === 'auto') {
      this.selectDefaultStore();
    } else if (this.preSelect) {
      this.selectedStoreId = this.preSelect.toString();
    }
  }

  selectDefaultStore() {
    this.stores.forEach((store: Store) => {
      if (store.is_default) {
        this.selectedStoreId = store.id?.toString() || '';
        return;
      }
    })
  }

  onValueChange(value: string) {
    this.selectedStoreId = value;
    const selectedStore = this.stores.find(s => s.id?.toString() === value);
    if (selectedStore) {
      this.storeSelected.emit(selectedStore);
    }
  }

}
